import { ToolbarButton } from 'src/app/models/toolbar-button/toolbar-button';
import { SettingsComponent } from './settings.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionGuard } from 'src/app/services/util/permission.guard';

const routes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    data: {
      activeLink: ToolbarButton.HOME,
      permissionRule: {
        allOf: Permission.VIEW_SETTINGS
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {

}
